import { type ReactNode, useRef } from 'react'

import { UiProvider } from 'src/design-system/ui'
import { MainScrollProvider } from 'src/layouts/_shared/MainScrollContext'
import { ProfessionalDocumentCanvas } from 'src/layouts/_shared/ProfessionalDocumentCanvas'
import { ProfessionalTopBar } from 'src/layouts/_shared/ProfessionalTopBar'
import { useProfessionalMode } from 'src/layouts/_shared/useProfessionalMode'

import '../_shared/professional-shell.css'

/** Shared Professional chrome for migrated internal pages. */
const ProfessionalDashboardLayout = ({
  children,
  actions,
  layout = 'page',
  navigation,
}: {
  children: ReactNode
  actions?: ReactNode
  layout?: 'page' | 'workspace'
  navigation?: (content: (leadingContent?: ReactNode) => ReactNode) => ReactNode
}) => {
  const mainRef = useRef<HTMLElement>(null)
  const appearance = useProfessionalMode()
  const content = (leadingContent?: ReactNode) => (
    <div className="professional-dashboard">
      <ProfessionalTopBar
        {...appearance}
        leadingContent={leadingContent}
        actions={actions}
      />
      <main
        ref={mainRef}
        className="professional-dashboard-main"
        data-layout={layout}
      >
        <MainScrollProvider value={mainRef}>{children}</MainScrollProvider>
      </main>
    </div>
  )
  return (
    <UiProvider theme="professional" mode={appearance.mode}>
      <ProfessionalDocumentCanvas />
      <div className="professional-dashboard-frame">
        {navigation ? navigation(content) : content()}
      </div>
    </UiProvider>
  )
}
export default ProfessionalDashboardLayout
